// Editable text, bars, tables and lines from the same scene used on screen/PDF.
// Only the decorative diagonal background is an SVG image.
const exportAdvisorPresentationPptx = async (PptxGenJS: any, scene: AdvisorScene, fileName: string) => {
  const pptx = new PptxGenJS();
  pptx.layout = 'LAYOUT_WIDE'; pptx.title = scene.title; pptx.author = 'Plumme';
  const scale = 13.333333 / scene.width;
  const hex = (color: string) => color.replace('#', '');
  for (const page of scene.pages) {
    const slide = pptx.addSlide();
    for (const node of page.nodes) {
      if (node.kind === 'text') slide.addText(node.text || '', {
        x: node.x * scale, y: node.y * scale, w: node.w! * scale, h: node.h! * scale,
        fontFace: scene.font, fontSize: node.size! * .75, bold: node.bold, color: hex(node.color),
        margin: 0, breakLine: false, valign: 'top', align: node.align || 'left', paraSpaceAfterPt: 0,
      });
      else if (node.kind === 'rect') slide.addShape(node.radius ? pptx.ShapeType.roundRect : pptx.ShapeType.rect, {
        x: node.x * scale, y: node.y * scale, w: node.w! * scale, h: node.h! * scale,
        radius: (node.radius || 0) * scale, rectRadius: (node.radius || 0) * scale,
        fill: { color: hex(node.color) }, line: { color: hex(node.color), transparency: 100 },
      });
      else if (node.kind === 'path' && node.fill) {
        const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="1280" height="720" viewBox="0 0 1280 720"><polygon points="${node.points!.map((p) => p.join(',')).join(' ')}" fill="${node.fill}"/></svg>`;
        slide.addImage({ data: 'data:image/svg+xml;base64,' + btoa(svg), x: 0, y: 0, w: 13.333333, h: 7.5 });
      } else {
        const points = node.kind === 'line' ? [[node.x, node.y], [node.x + node.w!, node.y + node.h!]] : node.points!;
        points.slice(1).forEach((point, i) => {
          const [x, y] = points[i], [xx, yy] = point;
          slide.addShape(pptx.ShapeType.line, { x: Math.min(x, xx) * scale, y: Math.min(y, yy) * scale,
            w: Math.abs(xx - x) * scale, h: Math.abs(yy - y) * scale, flipV: (xx - x) * (yy - y) < 0,
            line: { color: hex(node.color), width: node.kind === 'path' ? 1.5 : .8 },
          });
        });
      }
    }
  }
  await pptx.writeFile({ fileName });
  return { fileName };
};
Object.assign(window, { advisorPresentationPptx: exportAdvisorPresentationPptx });
